class Movizor {
	constructor(button) {
		this.button = button;
		this.offer = this.button.closest('article.offer');
		this.button.addEventListener('click', () => {
			this.toggle();
		});

		const open_map =
			new URLSearchParams(window.location.search).get('open_map');

		if (open_map) this.toggle();
	}

	toggle() {
		this.offer.classList.toggle('map_opened');
		this.changeTextElement();
	}

	changeTextElement() {
		const text_element = this.button.querySelector('[data-toggle-text]');
		[text_element.innerText, text_element.dataset.toggleText] =
			[text_element.dataset.toggleText, text_element.innerText];
	}
}

export { Movizor };
